import { createRoot } from 'react-dom/client'
import { createStyles } from 'antd-style'
import CallApp from 'callapp-lib'

import guideImg from '@/assets/images/wxDownload.png'
import { isWechat, isIos } from '@/utils/browser'
import reportAction from '@/utils/statistic'

const useStyles = createStyles(({ css }, open: boolean) => {
  return {
    container: css`
      position: fixed;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      background-color: rgba(0, 0, 0, .7);
      z-index: 9999;
    `,
    content: css`
      width: 100vw;
      height: 0;
      padding-bottom: 53.3333%;
      background-image: url(${guideImg});
      background-size: contain;
      background-position: 100% 100%;
      background-repeat: no-repeat;
    `,
  }
})

const Modal = ({ onClose }: any) => {
  const { styles } = useStyles()

  return (
    <div className={styles.container} onClick={onClose}>
      <div className={styles.content} />
    </div>
  )
}

export default function useDownloadApp() {
  const onClose = () => {
    const root = getRoot()
    root.unmount()
  }

  const getRoot = () => {
    let div = document.getElementById('wxProtal')
    if (!div) {
      div = document.createElement('div')
      div.id = 'wxProtal'
      document.body.appendChild(div)
    }
    return createRoot(div)
  }

  const showWxProtal = () => {
    const root = getRoot()
    root.render(<Modal onClose={onClose} />)
  }

  const launchApp = () => {
    reportAction({
      action: 'click_launchApp',
    })
    if (isWechat) {
      showWxProtal()
      return
    }

    const callLib = new CallApp({
      scheme: {
        protocol: 'zdtcapp',
      },
      appstore: 'https://apps.apple.com/cn/app/id6474421402',
      fallback: 'https://apps.apple.com/cn/app/id6474421402',
    })

    callLib.open({
      path: 'start',
      callback: () => {
        let uri = ''
        if (isIos) {
          uri = 'https://apps.apple.com/cn/app/id6474421402'
        } else {
          uri = 'https://zdtc-cdn.wair.ac.cn/app/app-release.apk'
        }
        window.location.href = uri
      },
    })
  }

  return {
    showWxProtal,
    launchApp,
  }
}
